export const byteArrayToInt16 = bytes => {
	return ((bytes[1] & 0xff) << 8) | (bytes[0] & 0xff);
};

export const int16toByteArray = value => {
	const bytes = [];
	bytes[0] = value & 0xff;
	bytes[1] = (value >> 8) & 0xff;
	return bytes;
};

export const readInt16 = input => {
	const result = byteArrayToInt16(input.readNBytes(2));
	return result;
};

export const writeInt16 = (output, value) => {
	return output.push(...int16toByteArray(value));
};

export const byteArrayToInt32 = bytes => {
	return ((bytes[3] & 0xff) << 24) | ((bytes[2] & 0xff) << 16) | ((bytes[1] & 0xff) << 8) | (bytes[0] & 0xff);
};

export const int32toByteArray = value => {
	const bytes = [];
	bytes[0] = value & 0xff;
	bytes[1] = (value >> 8) & 0xff;
	bytes[2] = (value >> 16) & 0xff;
	bytes[3] = (value >> 24) & 0xff;
	return bytes;
};

export const readInt32 = input => {
	const result = byteArrayToInt32(input.readNBytes(4));
	return result;
};

export const writeInt32 = (output, value) => {
	return output.push(...int32toByteArray(value));
};

export const byteArrayToInt64 = bytes => {
	return ((bytes[7] & 0xff) << 56) | ((bytes[6] & 0xff) << 48) | ((bytes[5] & 0xff) << 40) | ((bytes[4] & 0xff) << 32) | ((bytes[3] & 0xff) << 24) | ((bytes[2] & 0xff) << 16) | ((bytes[1] & 0xff) << 8) | (bytes[0] & 0xff);
};

export const int64toByteArray = value => {
	const bytes = [];
	bytes[0] = value & 0xff;
	bytes[1] = (value >> 8) & 0xff;
	bytes[2] = (value >> 16) & 0xff;
	bytes[3] = (value >> 24) & 0xff;
	bytes[4] = (value >> 32) & 0xff;
	bytes[5] = (value >> 40) & 0xff;
	bytes[6] = (value >> 48) & 0xff;
	bytes[7] = (value >> 56) & 0xff;
	return bytes;
};

export const readInt64 = input => {
	const result = byteArrayToInt64(input.readNBytes(8));
	return result;
};

export const writeInt64 = (output, value) => {
	return output.push(...int64toByteArray(value));
};

export const readBoolean = input => {
	const byte = input.readNBytes(1);
	return byte[0] > 0;
};

export const writeBoolean = (output, value) => {
	return output.push(value ? 1 : 0);
};

export const readDouble = input => {
	const view = new DataView(new ArrayBuffer(8));
	input.readNBytes(8).forEach(function (b, i) {
		view.setUint8(i, b);
	});
	const num = view.getFloat64(0, false);
	return num;
};

export const readFloat = input => {
	const view = new DataView(new ArrayBuffer(4));
	input.readNBytes(4).forEach(function (b, i) {
		view.setUint8(i, b);
	});
	const num = view.getFloat32(0, false);
	return num;
};

export const readBytes = input => {
	const length = readInt16(input);
	return input.readNBytes(length);
};

export const readString = input => {
	const bytes = readBytes(input);
	return new TextDecoder().decode(bytes);
};

export const readByte = input => {
	return input.readNBytes(1);
};
